import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/sendPushToUsers',
        name: 'sendPushToUsers',
        meta: { sideMenuLabel: "Invia push" },
        component: () => import("./views/sendPushToUsers.vue")
    },
];

export default routes;